import create from 'zustand';
import { AppConfigurationType, SessionTimeout, Store } from './types';
import { AlertBoxData } from '../components/types';

const useStore = create<Store>((set) => ({
    spinner: false,
    showSpinner: () => { set({ spinner: true }); },
    hideSpinner: () => { set({ spinner: false }); },
    alertBox: null,
    showAlertBox: (alertBox: AlertBoxData | null) => set({ alertBox }),
    sessionTimeout: null,
    setSessionTimeout: (sessionTimeout: SessionTimeout | null) => set({ sessionTimeout }),
    appVersionMismatch: false,
    setAppVersionMismatch: (appVersionMismatch: boolean) => set({ appVersionMismatch }),
    appConfiguration: null,
    setAppConfiguration: (
        appConfiguration: AppConfigurationType | null,
    ) => set({ appConfiguration }),
}));

export default useStore;
